import { Superficie } from './../../../models/superficie.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-superficie",
    templateUrl: "./superficie.component.html",
    styleUrls: ["./superficie.component.css"],
    providers: [FormService]
})
export class superficieComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public superficie: Superficie;
    public form;
    public temp_sup;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog) {

        this.form = new FormGroup({
            util1: new FormControl(''),
            comun1: new FormControl(''),
            total1: new FormControl(''),
            util2: new FormControl(''),
            comun2: new FormControl(''),
            total2: new FormControl(''),
            util3: new FormControl(''),
            comun3: new FormControl(''),
            total3: new FormControl(''),
            piso1: new FormControl(''),
            piso2: new FormControl(''),
            piso3: new FormControl(''),
            piso4: new FormControl(''),
            piso5: new FormControl(''),
            piso6: new FormControl(''),
            piso7: new FormControl(''),
            piso8: new FormControl(''),
            piso9: new FormControl(''),
            piso10: new FormControl(''),
            piso11: new FormControl(''),
            piso12: new FormControl(''),
            piso13: new FormControl(''),
            piso14: new FormControl(''),
            piso15: new FormControl('')
        })



        if (!JSON.parse(localStorage.getItem("superficie"))) {
            localStorage.setItem("superficie", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("superficie")); 0
        }

        this.superficie = { util1: '', comun1: '', total1: '', util2: '', comun2: '', total2: '', util3: '', comun3: '', total3: '', piso1: '', piso2: '', piso3: '', piso4: '', piso5: '', piso6: '', piso7: '', piso8: '', piso9: '', piso10: '', piso11: '', piso12: '', piso13: '', piso14: '', piso15: '' };
        this.temp_sup = { util1: '', comun1: '', total1: '', util2: '', comun2: '', total2: '', util3: '', comun3: '', total3: '', piso1: '', piso2: '', piso3: '', piso4: '', piso5: '', piso6: '', piso7: '', piso8: '', piso9: '', piso10: '', piso11: '', piso12: '', piso13: '', piso14: '', piso15: '' };

    }

    add_superficie() {

        this.actualRow = localStorage.getItem("superficie");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.util1 && !this.form.value.comun1 && !this.form.value.total1 && !this.form.value.util2 && !this.form.value.comun2 && !this.form.value.total2
            && !this.form.value.util2 && !this.form.value.comun2 && !this.form.value.total2 && !this.form.value.piso1 && !this.form.value.piso2 && !this.form.value.piso3 && !this.form.value.piso4
            && !this.form.value.piso5 && !this.form.value.piso6 && !this.form.value.piso7 && !this.form.value.piso8 && !this.form.value.piso9 && !this.form.value.piso10
            && !this.form.value.piso11 && !this.form.value.piso12 && !this.form.value.piso13 && !this.form.value.piso14 && !this.form.value.piso15) {
            console.log("no se ingresaron datos")
            this.dialog.open(this.openModalNODATA);
            //this.
        } else {
            this.rows = this.rows.concat({
                util1: this.form.value.util1,
                comun1: this.form.value.comun1,
                total1: this.form.value.total1,
                util2: this.form.value.util2,
                comun2: this.form.value.comun2,
                total2: this.form.value.total2,
                util3: this.form.value.util3,
                comun3: this.form.value.comun3,
                total3: this.form.value.total3,
                piso1: this.form.value.piso1,
                piso2: this.form.value.piso2,
                piso3: this.form.value.piso3,
                piso4: this.form.value.piso4,
                piso5: this.form.value.piso5,
                piso6: this.form.value.piso6,
                piso7: this.form.value.piso7,
                piso8: this.form.value.piso8,
                piso9: this.form.value.piso9,
                piso10: this.form.value.piso10,
                piso11: this.form.value.piso11,
                piso12: this.form.value.piso12,
                piso13: this.form.value.piso13,
                piso14: this.form.value.piso14,
                piso15: this.form.value.piso15
            })
            localStorage.setItem("superficie", JSON.stringify(this.rows));
            this.form.reset();
        }



    }
    delete_superficie(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("superficie");
        this.rows = JSON.parse(this.actualRow);
    }

    onChangeSelect(event) {
        let value = event.target.value;
        console.log(value);
    }

    get_superficie(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_sup.id = id;
                this.temp_sup.util1 = this.rows[x].util1;
                this.temp_sup.comun1 = this.rows[x].comun1;
                this.temp_sup.total1 = this.rows[x].total1;
                this.temp_sup.util2 = this.rows[x].util2;
                this.temp_sup.comun2 = this.rows[x].comun2;
                this.temp_sup.total2 = this.rows[x].total2;
                this.temp_sup.util3 = this.rows[x].util3;
                this.temp_sup.comun3 = this.rows[x].comun3;
                this.temp_sup.total3 = this.rows[x].total3;
                this.temp_sup.piso1 = this.rows[x].piso1;
                this.temp_sup.piso2 = this.rows[x].piso2;
                this.temp_sup.piso3 = this.rows[x].piso3;
                this.temp_sup.piso4 = this.rows[x].piso4;
                this.temp_sup.piso5 = this.rows[x].piso5;
                this.temp_sup.piso6 = this.rows[x].piso6;
                this.temp_sup.piso7 = this.rows[x].piso7;
                this.temp_sup.piso8 = this.rows[x].piso8;
                this.temp_sup.piso9 = this.rows[x].piso9;
                this.temp_sup.piso10 = this.rows[x].piso10;
                this.temp_sup.piso11 = this.rows[x].piso11;
                this.temp_sup.piso12 = this.rows[x].piso12;
                this.temp_sup.piso13 = this.rows[x].piso13;
                this.temp_sup.piso14 = this.rows[x].piso14;
                this.temp_sup.piso15 = this.rows[x].piso15;
                console.log(this.temp_sup);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_sup = { util1: '', comun1: '', total1: '', util2: '', comun2: '', total2: '', util3: '', comun3: '', total3: '', piso1: '', piso2: '', piso3: '', piso4: '', piso5: '', piso6: '', piso7: '', piso8: '', piso9: '', piso10: '', piso11: '', piso12: '', piso13: '', piso14: '', piso15: '' };

    }

    savesuperficie() {
        var id = this.temp_sup.id;
        console.log(this.temp_sup)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie", JSON.stringify(this.rows));
                $("#sup_modal").modal("hide");
                this.actualRow = localStorage.getItem("superficie");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    util1: this.temp_sup.util1,
                    comun1: this.temp_sup.comun1,
                    total1: this.temp_sup.total1,
                    util2: this.temp_sup.util2,
                    comun2: this.temp_sup.comun2,
                    total2: this.temp_sup.total2,
                    util3: this.temp_sup.util3,
                    comun3: this.temp_sup.comun3,
                    total3: this.temp_sup.total3,
                    piso1: this.temp_sup.piso1,
                    piso2: this.temp_sup.piso2,
                    piso3: this.temp_sup.piso3,
                    piso4: this.temp_sup.piso4,
                    piso5: this.temp_sup.piso5,
                    piso6: this.temp_sup.piso6,
                    piso7: this.temp_sup.piso7,
                    piso8: this.temp_sup.piso8,
                    piso9: this.temp_sup.piso9,
                    piso10: this.temp_sup.piso10,
                    piso11: this.temp_sup.piso11,
                    piso12: this.temp_sup.piso12,
                    piso13: this.temp_sup.piso13,
                    piso14: this.temp_sup.piso14,
                    piso15: this.temp_sup.piso15
                })
                localStorage.setItem("superficie", JSON.stringify(this.rows));
                // this.temp_sup.reset();
                this.dialog.closeAll();
            }
        }
    }

}